import styles from '../fanfic-reader-landing.module.css'

type SectionLabelProps = {
  text: string
  centered?: boolean
  className?: string
}

export function SectionLabel({ text, centered = false, className }: SectionLabelProps) {
  const classes = [
    styles.sectionLabel,
    centered ? styles.sectionLabelCentered : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} data-reveal="true">
      <span className={styles.sectionLabelDot} aria-hidden="true" />
      <span className={styles.sectionLabelText}>{text}</span>
    </div>
  )
}
